import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Archive } from "@phosphor-icons/react";
import { DashboardLayout } from "../components/layout/DashboardLayout";
import { api, formatApiErrorDetail } from "../lib/api";
import { formatET } from "../lib/dateUtils";

const navItems = [{ to: "/admin/discards", label: "Discard Log", icon: <Archive size={18} weight="duotone" />, testId: "nav-admin-discards" }];

const CATEGORY_LABEL = { trust: "Trust & Asset Protection", funding: "Funding" };

export default function AdminDiscardLogPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/website-visitors/discards")
      .then(({ data }) => setRows(data))
      .catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <DashboardLayout navItems={navItems} moduleName="Discard Log" moduleBackPath="/admin">
      <div data-testid="admin-discard-log-page">
        <h1 className="font-serif text-3xl text-igc-cream tracking-tight mb-1" title="Every LOW-confidence website visitor that was discarded automatically before ever reaching the review queue.">
          Discard Log
        </h1>
        <p className="text-igc-muted text-sm mb-6">
          Read-only. Every LOW-confidence visitor auto-discarded before reaching the queue, newest first — for sanity checks only, no actions here.
        </p>

        <div className="border border-igc-gold/15 rounded-lg overflow-hidden">
          <table className="w-full text-sm" data-testid="admin-discard-log-table">
            <thead>
              <tr className="bg-igc-surfaceLight text-igc-muted text-left border-b border-igc-gold/10">
                <th className="p-3">Visitor Name</th>
                <th className="p-3">Website Source</th>
                <th className="p-3">Discard Reason</th>
                <th className="p-3">Date Discarded</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr><td colSpan={4} className="p-6 text-center text-igc-muted" data-testid="admin-discard-log-loading">Loading...</td></tr>
              )}
              {!loading && rows.length === 0 && (
                <tr><td colSpan={4} className="p-6 text-center text-igc-muted" data-testid="admin-discard-log-empty">No discarded visitors yet.</td></tr>
              )}
              {rows.map((r) => (
                <tr key={r.id} data-testid={`admin-discard-log-row-${r.id}`} className="border-b border-igc-gold/5">
                  <td className="p-3 text-igc-cream">{r.name || "Unidentified Visitor"}</td>
                  <td className="p-3 text-igc-goldText">{CATEGORY_LABEL[r.category] || r.category}</td>
                  <td className="p-3 text-igc-muted">{r.reason}</td>
                  <td className="p-3 text-igc-muted">{r.discarded_at ? formatET(r.discarded_at) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
